import { render } from "./VtoHotswapHaircolor.vue?vue&type=template&id=660db1ef"
import script from "./VtoHotswapHaircolor.vue?vue&type=script&lang=js"
export * from "./VtoHotswapHaircolor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__